"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VISUALLYHIDDEN_CATEGORY_KEY = 'base';
exports.VISUALLYHIDDEN_COMPONENT_KEY = 'visuallyHidden';